export const checkComment = (content) => {
    const rule = /([\d①②③④⑤⑥⑦⑧⑨⑩零一二三四五六七八九十][\s，。、？?！!/.；;\-~|*+@#＃￥%&\u4e00-\u9fa5]{0,3}){11}/
    return rule.test(content)
}